import { DateTime } from 'luxon';

export const dollars = amount => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  return formatter.format(amount);
};

export const currency = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  });

  return formatter.format(value);
};

export const delimited = value => {
  if (!value && 0 !== value && '0' !== value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };

  const formatter = new Intl.NumberFormat('en-US', {});

  return formatter.format(value);
}

export const dateShort = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };
  if (!value) { return ''; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATE_SHORT);
};

export const datetimeShort = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };
  if (!value) { return ''; }

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATETIME_SHORT);
};

export const datetimeMedium = value => {
  if (!value) { return ''; }
  if ('undefined' !== typeof value.value) { value = value.value };

  return DateTime.fromISO(value).
    toLocaleString(DateTime.DATETIME_MED);
};

const UPPERCASE_WORDS = [
  'llc',
  'usa'
];

export const titlecase = value => {
  if (!value) { return ''; }

  return value.trim().toLowerCase().split(/\s/).map(word => {
    if (UPPERCASE_WORDS.includes(word)) {
      return word.toUpperCase();
    }

    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
}

export const truncate = (word, { limit }) => {
  if (!word) return '';
  if (!limit) return word;

  return `${word.substring(0, limit)}${word.length < limit ? '' : '...'}`;
};

export const phoneNumber = value => {
  if (value && value.startsWith('+1')) {
    return `(${value.substring(2,5)}) ${value.substring(5,8)}-` +
      value.substring(8,12);
  }

  return value;
};
